const OfferValidation = (values) => {
  const errors = {};

  //if (!values.conditions) return errors;
  if (!values.items) return errors;
  if (!values.name) {
    errors.name = "Name is required";
  }
  if (!values.status) {
    // You can return translation keys
    errors.status = "Status is required";
  }

  // if (
  //   values.conditions &&
  //   values.conditions.length > 0 &&
  //   !values.conditions[0]?.value &&
  //   values.conditions[0]?.value !== 0
  // ) {
  //   errors.conditions = [{ value: "Condition value is required" }];
  // }

  // if (values.items && values.items.length > 0 && !values.items[0]?.value) {
  //   errors.items = [{ value: "Benefit value is required" }];
  //   //errors.display = "Value is required";
  // }

  // if (!values.offer_condition_id) {
  //   // You can return translation keys
  //   errors.offer_condition_id = "Condition is required";
  // }
  // if (!values.condition_value && values.condition_value !== 0) {
  //   // You can return translation keys
  //   errors.condition_value = "this value is required";
  // }
  // if (!values.coupon_id) {
  //   // You can return translation keys
  //   errors.coupon_id = "Benefit is required";
  // }
  // if (!values.coupon_value && values.coupon_value !== 0) {
  //   // You can return translation keys
  //   errors.coupon_value = "Value is required";
  // }

  return errors;
};

export default OfferValidation;
